import { atom } from 'recoil';

export const footerH2Width = atom({
  key: 'footerH2Width',
  default: 0,
});
